import React from 'react';
import { contact, identity } from '../data/portfolio';
import { Label } from './Label';
const links = [{
  label: 'Email',
  value: contact.email,
  href: `mailto:${contact.email}`,
  external: false
}, {
  label: 'Telephone',
  value: contact.phone,
  href: `tel:${contact.phone.replace(/[^+\d]/g, '')}`,
  external: false
}, {
  label: 'LinkedIn',
  value: contact.linkedin,
  href: contact.linkedinUrl,
  external: true
}];
export function Contact() {
  return <footer id="contact" className="scroll-mt-20 border-t border-white/10 bg-ink-900 px-6 py-20 md:px-10 md:py-24" data-id="element-82" data-mp="3szkhjcn49zrb">
      <div className="mx-auto w-full max-w-edge" data-id="element-83" data-mp="3k4mgfi9tfgow">
        <Label data-id="element-84" data-mp="3k3bdtls3wezd">Contact</Label>

        <ul className="mt-12 border-t border-white/15" data-id="element-85" data-mp="3f6l2tcv5s9kt">
          {links.map(link => <li key={link.label} className="border-b border-white/15" data-id="element-86" data-mp="gg2p62x4f6j7">
              <a href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noreferrer' : undefined} className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-2 py-7 transition-colors duration-150 ease-editorial hover:text-brass focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-brass" data-id="element-87" data-mp="gifi1b4f31b1">
                <span className="text-[0.75rem] uppercase tracking-[0.3em] text-fog" data-id="element-88" data-mp="3f3t761pvwcs3">
                  {link.label}
                </span>
                <span className="font-display text-xl text-paper transition-colors duration-150 ease-editorial hover:text-brass md:text-2xl" data-id="element-89" data-mp="3176am01ufomp">
                  {link.value}
                </span>
              </a>
            </li>)}
        </ul>

        <div className="mt-16 flex flex-col gap-3 text-[0.7rem] uppercase tracking-[0.24em] text-fog sm:flex-row sm:items-center sm:justify-between" data-id="element-90" data-mp="2w58lip6rhzlu">
          <span data-id="element-91" data-mp="qaxth24ee22y">
            {identity.name} · {identity.role}
          </span>
          <span data-id="element-92" data-mp="ue3w7zsaxb4o">{identity.location}</span>
          <a href={contact.websiteUrl} className="text-brass transition-colors duration-150 ease-editorial hover:text-paper" data-id="element-93" data-mp="23bc3l41y8hzi">
            {contact.website}
          </a>
          <span data-id="element-94" data-mp="1uamd8fvgjjt6">© {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>;
}